// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3QPiN","rowsWrapper":"style_rowsWrapper__3hIJA","rowWrapper":"style_rowWrapper__24B2q"};